import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Component, OnInit, inject, DestroyRef } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { switchMap } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { DmsService } from '@app/core/services/dms/dms.service';

export function objectToQueryString(obj: Record<string, any>) {
	const queryParams: string[] = [];

	for (const key in obj) {
		if (obj.hasOwnProperty(key)) {
			const value = obj[key];
			// queryParams.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`); //TODO: check which way is correct
			queryParams.push(`${key}=${value}`);
		}
	}

	return queryParams.join('&');
}

@Component({
	selector: 'dms-login',
	templateUrl: './dms-login.component.html',
	styleUrls: ['./dms-login.component.scss'],
	standalone: false
})
export class DmsLoginComponent implements OnInit {
	private readonly destroyRef: DestroyRef = inject(DestroyRef);

	private activatedRoute = inject(ActivatedRoute);
	private translateService = inject(TranslateService);
	private dmsService = inject(DmsService);

	private readonly subdomain: string;

	private queryParams: Params;

	constructor() {
		this.subdomain = window.location.hostname.split('.')[0];
	}

	ngOnInit(): void {
		this.activatedRoute.queryParams
			.pipe(
				takeUntilDestroyed(this.destroyRef),
				switchMap((queryParams: Params) => {
					this.queryParams = queryParams;
					return this.dmsService.getEncryptedDmsToken();
				})
			)
			.subscribe(res => {
				this.redirectToDms(res.token);
			});
	}

	private redirectToDms(token: string): void {
		this.queryParams = {
			...this.queryParams,
			lng: this.translateService.currentLang,
			token
		};
		const queryParamsAsString: string = objectToQueryString(this.queryParams);
		let dmsUrl: string = `${this.dmsService.dmsFrontendUrl}add-in/`;

		if (this.queryParams.hasOwnProperty('type') && this.queryParams.type === 'outlook') {
			dmsUrl += 'file';
		}

		window.location.href = `${dmsUrl}?${queryParamsAsString}`;
	}
}
